import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm } from "availity-reactstrap-validation";
import "react-datepicker/dist/react-datepicker.css";
import Select, { components } from "react-select";
import {
  Button,
  Card,
  Col,
  Container,
  FormGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
  UncontrolledCollapse,
  CardBody,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { portFetchAll } from "../../../../actions/portAction";
import { dummyData, formatRupiah } from "helpers";
import {
  listShipperFetchSub,
  searchSimulasiTarifNew,
  typeContainerPortal,
} from "actions/simulasiTarifAction";
import { shipperFetchAll } from "actions/shipperAction";
import NumberFormat from "react-number-format";

let pages = [];
let curPage, totalPages, prevPage, nextPage, minPage, maxPage;

class SimulasiTarif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curPage: 1,
      start: 0,
      perPage: 10,
      port_origin_label: "",
      port_origin: "",
      port_destination_label: "",
      port_destination: "",
      kuota: 1,
      containerCount: "",
      selectedShipper: null,
      shipperList: null,
      containers: [{ type_container_id: 0, quota_container: null }],
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSelect(opt, key) {
    this.setState({
      ...this.state,
      [key]: opt.value,
      [`${key}_label`]: opt.label,
    });
  }

  calculateTotalQuotaDry = () => {
    const dryContainer = this.state.containers.filter(
      (val) => val.type_container_id === 1 || val.type_container_id === 5
    );
    const totalQuotaDry = dryContainer.reduce(
      (a, b) => a + b.quota_container,
      0
    );
    return totalQuotaDry;
  };

  calculateQuotaReefer = () => {
    const reeferContainer = this.state.containers.filter(
      (val) => val.type_container_id === 2 || val.type_container_id === 6
    );
    const totalQuotaReefer = reeferContainer.reduce(
      (a, b) => a + b.quota_container,
      0
    );
    return totalQuotaReefer;
  };

  calculateQuotaCurah = () => {
    const curah = this.state.containers.filter(
      (val) => val.type_container_id === 3
    );
    const totalQuotaCurah = curah.reduce((a, b) => a + b.quota_container, 0);
    return totalQuotaCurah;
  };

  calculateQuotaBox = () => {
    const box = this.state.containers.filter(
      (val) => val.type_container_id === 4
    );
    const totalQuotaBox = box.reduce((a, b) => a + b.quota_container, 0);
    return totalQuotaBox;
  };

  handleSearch() {
    const isContainersValid = this.state.containers.every(
      (container) =>
        container.type_container_id && container.quota_container !== undefined
    );

    if (!isContainersValid) {
      alert("Harap pilih kontainer dan masukkan kuota untuk setiap kontainer.");
      return;
    }

    const totalQuotaContainerDry = this.calculateTotalQuotaDry();
    const totalQuotaContainerReefer = this.calculateQuotaReefer();
    const totalQuotaCargoCurah = this.calculateQuotaCurah();
    const totalQuotaCurahBox = this.calculateQuotaBox();

    const data = {
      start: 0,
      length: this.state.perPage,
      shipper_id: this.state.selectedShipper.value,
      containers: this.state.containers,
      total_quota_container_dry: totalQuotaContainerDry,
      total_quota_container_reefer: totalQuotaContainerReefer,
      total_cargo_curah: totalQuotaCargoCurah,
      total_cargo_box: totalQuotaCurahBox,
    };

    if (this.state.port_origin) data.port_origin_id = this.state.port_origin;
    if (this.state.port_destination)
      data.port_destination_id = this.state.port_destination;

    this.props.searchSimulasiTarif(data);
  }

  componentDidMount() {
    let type_container = [1, 2, 3, 4, 5, 6];

    this.props.portFetchAll();
    this.props.typeContainerPortal({ type_container: type_container });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
      };
      data.start = this.state.curPage * 10 - 10;
      this.props.searchSimulasiTarif(data);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { port_origin, port_destination } = this.state;

    if (
      port_origin &&
      port_destination &&
      (port_origin !== prevState.port_origin ||
        port_destination !== prevState.port_destination)
    ) {
      this.props.listShipperFetchSub(port_origin, port_destination);
    }

    if (prevProps.listShipper !== this.props.listShipper) {
      this.setState({
        shipperList: this.props.listShipper,
      });
    }
  }

  handleShipperChange = (trayek_id, selectedShipper) => {
    this.setState({
      selectedShipper: {
        ...this.state.selectedShipper,
        [trayek_id]: JSON.parse(selectedShipper),
      },
    });
  };

  getCurrentTotalTarifDry = (item) => {
    return (
      +item.tarif_container[0].tarif_dry +
      +item.tarif_depo.total +
      +item.tarif_pelabuhan.reduce((a, b) => a + b.total, 0) +
      +item.shipper.reduce((a, b) => a + b.total_all_tarif_shipper, 0)
    );
  };

  getCurrentTotalTarifReefer = (item) => {
    return (
      +item.tarif_container[0].tarif_reefer +
      +item.tarif_depo.total +
      +item.tarif_pelabuhan.reduce((a, b) => a + b.total, 0) +
      +item.shipper.reduce((a, b) => a + b.total_all_tarif_shipper, 0)
    );
  };

  getCurrentTotalTarifLclDry = (item) => {
    return (
      +item.tarif_container[0].lcl_dry +
      +item.tarif_depo.total_percontainer +
      +item.tarif_pelabuhan.reduce((a, b) => a + b.total_percontainer, 0) +
      +item.shipper.reduce((a, b) => a + b.total_percontainer_tarif_shipper, 0)
    );
  };

  getCurrentTotalTarifLclReefer = (item) => {
    return (
      +item.tarif_container[0].lcl_reefer +
      +item.tarif_depo.total +
      +item.tarif_pelabuhan.reduce((a, b) => a + b.total, 0) +
      +item.shipper.reduce((a, b) => a + b.total_percontainer_tarif_shipper, 0)
    );
  };

  handleContainerChange(index, field, value) {
    const containers = [...this.state.containers];
    containers[index][field] = value;
    this.setState({ containers });
  }

  tambahContainer() {
    this.setState((prevState) => ({
      containers: [
        ...prevState.containers,
        { type_container_id: 0, quota_container: null },
      ],
    }));
  }

  hapusContainer(index) {
    this.setState((prevState) => {
      const containers = [...prevState.containers];
      containers.splice(index, 1);
      return { containers };
    });
  }

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }
    return rupiah;
  }

  calculateTotalTarif = (item) => {
    return (
      item.tarif_container.total +
      item.tarif_depo.total +
      item.tarif_pelabuhan.total +
      (item.tarif_shipper.length > 0 ? item.tarif_shipper[0].total : 0)
    );
  };

  render() {
    const defaultValues = {
      port_origin_label: this.state.port_origin_label
        ? this.state.port_origin_label
        : "-- Pelabuhan Asal --",
      port_origin: this.state.port_origin,
      port_destination_label: this.state.port_destination_label
        ? this.state.port_destination_label
        : "-- Pelabuhan Tujuan --",
      port_destination: this.state.port_destination,
      selectedShipper: this.state.selectedShipper
        ? this.state.selectedShipper
        : "-- pilih shipper --",
    };

    if (this.props.searchSimulasiTarifSuccess) {
      curPage = +this.props.simulasiTarif?.currentPage;

      prevPage = curPage - 1;
      nextPage = curPage + 1;

      minPage = curPage - 2;
      maxPage = curPage + 2;

      pages = [];
      totalPages = this.props.simulasiTarif?.pageTotal;
      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) === -1) {
          pages.push(index);
        }
      }
    }

    const customStyle = {
      control: (base) => ({
        ...base,
        border: 0,
        color: "red",
        backgroundColor: "#edf3ff",
        boxShadow: "none",
      }),
    };

    const DropdownIndicator = (props) => {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            <i
              className="fa fa-caret-down"
              style={{ color: "#224B98" }}
              aria-hidden="true"
            ></i>
          </components.DropdownIndicator>
        )
      );
    };

    const Control = ({ children, ...props }) => (
      <components.Control {...props} style={{ borderRadius: "25px" }}>
        {props.selectProps.id === "port_origin" ? (
          <i
            className="fa fa-anchor"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          >
            <sup style={{ top: "-10px" }}>
              <i
                className="fa fa-arrow-right"
                style={{ transform: "rotate(-40deg)", fontSize: "6px" }}
                aria-hidden="true"
              ></i>
            </sup>
          </i>
        ) : props.selectProps.id === "port_destination" ? (
          <i
            className="fa fa-anchor"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          >
            <sup style={{ top: "-10px" }}>
              <i
                className="fa fa-arrow-right"
                style={{ transform: "rotate(40deg)", fontSize: "6px" }}
                aria-hidden="true"
              ></i>
            </sup>
          </i>
        ) : props.selectProps.id === "month" ? (
          <i
            className="fa fa-calendar-o"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : props.selectProps.id === "status" ? (
          <i
            className="fa fa-ship"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : props.selectProps.id === "selectedShipper" ? (
          <i
            className="fa fa-user"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : props.selectProps.id.includes("type_container") ? (
          <i
            className="fa fa-cube"
            style={{ color: "#224B98" }}
            aria-hidden="true"
          ></i>
        ) : (
          props.selectProps.id === "quota_container" && (
            <i
              className="fa fa-pencil"
              style={{ color: "#224B98" }}
              aria-hidden="true"
            ></i>
          )
        )}{" "}
        {children}
      </components.Control>
    );

    const IconOption = (props) => (
      <components.Option {...props}>{props.data.label}</components.Option>
    );

    return (
      <div
        style={{
          backgroundColor: "#3B6ECE",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Container>
          <Card
            style={{
              position: "relative",
              top: -70,
              padding: "0 28px",
              borderRadius: 30,
            }}
          >
            <AvForm
              onValidSubmit={this.handleSearch}
              style={{
                backgroundColor: `rgba(${109}, ${157}, ${249}, ${0.12})`,
                margin: "34px 0 10px",
                padding: "30px 30px 14px",
                borderRadius: 10,
              }}
            >
              <Row>
                {this.props.portGetSuccess && (
                  <>
                    <Col md="12" lg="">
                      <FormGroup>
                        <Select
                          id="port_origin"
                          name="port_origin"
                          value={this.state.port_origin.port_origin}
                          defaultValue={{
                            label: defaultValues.port_origin_label,
                            value: defaultValues.port_origin,
                          }}
                          onChange={(opt) =>
                            this.handleSelect(opt, "port_origin")
                          }
                          styles={customStyle}
                          components={{
                            Control,
                            Option: IconOption,
                            DropdownIndicator,
                            IndicatorSeparator: () => null,
                          }}
                          options={this.props.ports.data}
                        />
                      </FormGroup>
                    </Col>

                    <hr className="vertical d-none d-lg-block" />

                    <Col md="12" lg="">
                      <FormGroup>
                        <Select
                          id="port_destination"
                          name="port_destination"
                          value={this.state.port_destination.port_destination}
                          defaultValue={{
                            label: defaultValues.port_destination_label,
                            value: defaultValues.port_destination,
                          }}
                          onChange={(opt) =>
                            this.handleSelect(opt, "port_destination")
                          }
                          styles={customStyle}
                          components={{
                            Control,
                            Option: IconOption,
                            DropdownIndicator,
                            IndicatorSeparator: () => null,
                          }}
                          options={this.props.ports.data}
                        />
                      </FormGroup>
                    </Col>
                    <hr className="vertical d-none d-lg-block" />

                    <Col md="12" lg="">
                      <FormGroup>
                        <Select
                          id="selectedShipper"
                          name="selectedShipper"
                          value={this.state.selectedShipper}
                          placeholder="-- Pilih Shipper --"
                          onChange={(opt) =>
                            this.setState({ selectedShipper: opt })
                          }
                          styles={customStyle}
                          components={{
                            Control,
                            Option: IconOption,
                            DropdownIndicator,
                            IndicatorSeparator: () => null,
                          }}
                          options={this.state.shipperList?.data?.map(
                            (shipper) => ({
                              label: shipper.nama_perusahaan,
                              value: shipper.users_id,
                            })
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
              </Row>
              {this.state.containers.map((container, index) => (
                <Row>
                  <React.Fragment key={index}>
                    <Col md="12" lg="">
                      <FormGroup>
                        <Select
                          id={`type_container_${index}`}
                          name={`type_container_${index}`}
                          value={container.type_container_id.value}
                          onChange={(opt) =>
                            this.handleContainerChange(
                              index,
                              "type_container_id",
                              opt.value
                            )
                          }
                          styles={customStyle}
                          components={{
                            Control,
                            Option: IconOption,
                            DropdownIndicator,
                            IndicatorSeparator: () => null,
                          }}
                          placeholder="-- Pilih Kontainer --"
                          options={this.props.typeContainers?.data?.map(
                            (container) => ({
                              value: container.id,
                              label: container.type_container_name,
                            })
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <hr className="vertical d-none d-lg-block" />
                    <Col md="12" lg="">
                      <FormGroup>
                        <Input
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="number"
                          id="quota_container"
                          placeholder={`-- Masukan Kuota ${index + 1} --`}
                          value={container.quota_container}
                          onChange={(e) =>
                            this.handleContainerChange(
                              index,
                              "quota_container",
                              +e.target.value
                            )
                          }
                          styles={customStyle}
                          components={{
                            Control,
                            Option: IconOption,
                            DropdownIndicator,
                            IndicatorSeparator: () => null,
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <hr className="vertical d-none d-lg-block" />
                  </React.Fragment>

                  <Col md="12" lg="">
                    {index > 0 && (
                      // <Col md="auto">
                      <Button
                        type="button"
                        onClick={() => this.hapusContainer(index)}
                        style={{
                          marginRight: 5,
                          backgroundColor: "rgb(34, 75, 152)",
                          color: "white",
                        }}
                      >
                        <i className="fa fa-trash"></i> Hapus
                      </Button>
                      // </Col>
                    )}
                    <Button
                      type="button"
                      onClick={() => this.tambahContainer()}
                      style={{
                        backgroundColor: "rgb(34, 75, 152)",
                        color: "white",
                      }}
                    >
                      <i className="fa fa-plus"></i> Tambah Kontainer
                    </Button>
                  </Col>
                </Row>
              ))}
              <Row>
                <Col>
                  <Button
                    className="w-100"
                    style={{
                      backgroundColor: "#224B98",
                      color: "white",
                    }}
                    type="submit"
                  >
                    Cari <i className="fa fa-search"></i>
                  </Button>
                </Col>
              </Row>
            </AvForm>

            {(this.props.searchSimulasiTarifError ||
              this.props.portGetError) && (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <p>
                  Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi
                  dengan internet
                </p>
              </div>
            )}

            {(this.props.searchSimulasiTarifLoading ||
              this.props.portGetLoading) && (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner color="primary" size="lg" />
              </div>
            )}

            {this.props.searchSimulasiTarifSuccess &&
              this.props.portGetSuccess && (
                <>
                  {/* <div
                    style={{
                      overflowX: "auto",
                      maxHeight: "500px",
                      overflowY: "scroll",
                      // transform: "rotateX(180deg)",
                      // transformOrigin: "top",
                    }}
                  > */}
                  {/* <div style={{ transform: "rotateX(180deg)" }}> */}
                  <Table
                    borderless
                    responsive
                    style={{
                      color: "#224B98",
                      // width: "150%",
                      tableLayout: "auto",
                      // transform: "rotateX(180deg)",
                    }}
                  >
                    <thead>
                      <tr>
                        <th>Kode Trayek</th>
                        {/* <th>Origin</th> */}
                        {/* <th>Destination</th> */}
                        <th>Total Tarif Kontainer</th>
                        <th>Tarif Pelabuhan</th>
                        <th>Tarif Depo</th>
                        <th>Tarif Shipper</th>
                        {/* <th>Shipper</th> */}
                        <th>Total Tarif</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.simulasiTarif.data.length === 0 && (
                        <tr>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                            colSpan="7"
                          >
                            Data tidak ditemukan
                          </td>
                        </tr>
                      )}

                      {this.props.simulasiTarif.data &&
                        this.props.simulasiTarif.data.map((item, index) => (
                          <React.Fragment key={index}>
                            <tr key={`fare-${index}`}>
                              <td>
                                <div>{item.kode_trayek}</div>
                              </td>
                              <td>
                                <div style={{ fontWeight: "bold" }}>
                                  {formatRupiah(item.tarif_container.total)}
                                </div>
                              </td>
                              <td>
                                <div>
                                  Tarif Pelabuhan Asal :{" "}
                                  {formatRupiah(
                                    item.tarif_pelabuhan.tarif[0].total
                                  )}
                                </div>
                                <div>
                                  Tarif Pelabuhan Tujuan :{" "}
                                  {formatRupiah(
                                    item.tarif_pelabuhan.tarif[1].total
                                  )}
                                </div>
                                <div style={{ fontWeight: "bold" }}>
                                  Total Tarif :{" "}
                                  {formatRupiah(item.tarif_pelabuhan.total)}
                                </div>
                              </td>
                              <td>
                                <div>
                                  Tarif Depo Asal :{" "}
                                  {formatRupiah(
                                    item.tarif_depo.depo_origin_amount
                                  )}
                                </div>
                                <div>
                                  Tarif Depo Tujuan :{" "}
                                  {formatRupiah(
                                    item.tarif_depo.depo_destination_amount
                                  )}
                                </div>
                                <div style={{ fontWeight: "bold" }}>
                                  Total Tarif :{" "}
                                  {formatRupiah(item.tarif_depo.total)}
                                </div>
                              </td>
                              <td style={{ fontWeight: "bold" }}>
                                {" "}
                                {item.tarif_shipper.length > 0
                                  ? formatRupiah(item.tarif_shipper[0].total)
                                  : `Rp. 0`}
                              </td>
                              <td style={{ fontWeight: "bold" }}>
                                {formatRupiah(item.total_all)}
                                {/* {formatRupiah(this.calculateTotalTarif(item))} */}
                              </td>
                              {/* <td>
                                {item.tarif_container.map((i, idx) => (
                                  <div
                                    key={idx}
                                    style={{ display: "inline-block" }}
                                  >
                                    {i.size_container === "curah/box" &&
                                    i.lcl_dry === 0 &&
                                    i.tarif_dry === 0 &&
                                    i.lcl_reefer === 0 &&
                                    i.tarif_reefer === 0 ? null : (
                                      <>
                                        {idx + 1}. Ukuran Kontainer:{" "}
                                        {i.size_container}
                                        <div style={{ marginLeft: 8 }}>
                                          - Tarif LCL Dry:{" "}
                                          {formatRupiah(i.lcl_dry)}
                                        </div>
                                        <div style={{ marginLeft: 8 }}>
                                          - Tarif Dry:{" "}
                                          {formatRupiah(i.tarif_dry)}
                                        </div>
                                        <div style={{ marginLeft: 8 }}>
                                          - Tarif LCL Reefer:{" "}
                                          {formatRupiah(i.lcl_reefer)}
                                        </div>
                                        <div style={{ marginLeft: 8 }}>
                                          - Tarif Reefer:{" "}
                                          {formatRupiah(i.tarif_reefer)}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                ))}
                              </td> */}

                              {/* <td>
                                {item.tarif_pelabuhan.map((i, idx) => (
                                  <div
                                    key={idx}
                                    style={{ display: "inline-block" }}
                                  >
                                    {idx + 1}. Pelabuhan: {i.pelanbuhan}
                                    <div style={{ marginLeft: 8 }}>
                                      - Tarif Stevedoring:{" "}
                                      {formatRupiah(i.steve_doring_amount)}
                                    </div>
                                    <div style={{ marginLeft: 8 }}>
                                      - Tarif Cargodoring:{" "}
                                      {formatRupiah(i.cargo_doring_amount)}
                                    </div>
                                    <div style={{ marginLeft: 8 }}>
                                      - Tarif Receiving/Delivery:{" "}
                                      {formatRupiah(i.receiving_amount)}
                                    </div>
                                    <div style={{ marginLeft: 8 }}>
                                      - Tarif Paket Bongkar Muat:{" "}
                                      {formatRupiah(i.bongkar_muat_amount)}
                                    </div>
                                    <div style={{ marginLeft: 8 }}>
                                      - Subsidi: {formatRupiah(i.subsidi)}
                                    </div>
                                    <div
                                      style={{
                                        marginLeft: 8,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      - Total Tarif: {formatRupiah(i.total)}
                                    </div>
                                  </div>
                                ))}
                              </td> */}
                              {/* <td>
                                <div style={{ display: "inline-block" }}>
                                  <div style={{ marginLeft: 8 }}>
                                    - Tarif Depo Asal:{" "}
                                    {formatRupiah(
                                      item.tarif_depo.depo_origin_amount
                                    )}
                                  </div>
                                  <div style={{ marginLeft: 8 }}>
                                    - Tarif Depo Tujuan:{" "}
                                    {formatRupiah(
                                      item.tarif_depo.depo_destination_amount
                                    )}
                                  </div>
                                  <div style={{ marginLeft: 8 }}>
                                    - Subsidi Depo:{" "}
                                    {formatRupiah(
                                      item.tarif_depo.subsidi_depo_amount
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    - Total Tarif Depo:{" "}
                                    {formatRupiah(item.tarif_depo.total)}
                                  </div>
                                </div>
                              </td> */}
                              {/* <td>
                                {this.state.selectedShipper !== null &&
                                  !!this.state.selectedShipper[
                                    item.trayek_id
                                  ] &&
                                  this.state?.selectedShipper[
                                    item.trayek_id
                                  ].tarif_shipper.map((tarif) => (
                                    <div style={{ display: "inline-block" }}>
                                      Nama Tarif: {tarif.nama_tarif}
                                      <div style={{ marginLeft: 8 }}>
                                        - Jumlah Kontainer: {tarif.container}
                                      </div>
                                      <div style={{ marginLeft: 8 }}>
                                        - Harga Tarif: {tarif.nominal}
                                      </div>
                                      <div
                                        style={{
                                          marginLeft: 8,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        - Total Tarif: {tarif.total}
                                      </div>
                                    </div>
                                  ))}
                              </td> */}
                              {/* <td>{this.getCurrentTotal(item)}</td> */}

                              {/* <td>
                                {item.shipper.length > 0 && (
                                  <div>
                                    <FormGroup>
                                      <Input
                                        type="select"
                                        style={{ width: "200px" }}
                                        onChange={(e) => {
                                          console.log(e.target.value);
                                          this.handleShipperChange(
                                            item.trayek_id,
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option disabled selected>
                                          -- pilih shipper --
                                        </option>
                                        {item.shipper.map(
                                          (shipper, shipperIndex) => (
                                            <option
                                              key={shipperIndex}
                                              value={JSON.stringify(shipper)}
                                            >
                                              {shipper.nama_perusahaan}
                                            </option>
                                          )
                                        )}
                                      </Input>
                                    </FormGroup>
                                  </div>
                                )}
                              </td> */}
                              {/* <td>
                                <div style={{ display: "inline-block" }}>
                                  <div
                                    style={{
                                      marginLeft: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    - Total Tarif Dry:{" "}
                                    {this.state.selectedShipper !== null &&
                                    !!this.state.selectedShipper[item.trayek_id]
                                      ? formatRupiah(
                                          this.getCurrentTotalTarifDry(item)
                                        )
                                      : 0}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    - Total Tarif Reefer:{" "}
                                    {this.state.selectedShipper !== null &&
                                    !!this.state.selectedShipper[item.trayek_id]
                                      ? formatRupiah(
                                          this.getCurrentTotalTarifReefer(item)
                                        )
                                      : 0}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    - Total Tarif LCL Dry(per 1 container):{" "}
                                    {this.state.selectedShipper !== null &&
                                    !!this.state.selectedShipper[item.trayek_id]
                                      ? formatRupiah(
                                          this.getCurrentTotalTarifLclDry(item)
                                        )
                                      : 0}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: 8,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    - Total Tarif LCL Reefer(per 1 container):{" "}
                                    {this.state.selectedShipper !== null &&
                                    !!this.state.selectedShipper[item.trayek_id]
                                      ? formatRupiah(
                                          this.getCurrentTotalTarifLclReefer(
                                            item
                                          )
                                        )
                                      : 0}
                                  </div>
                                </div>
                              </td> */}
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </Table>
                  {/* </div> */}
                  {/* </div> */}

                  {/* <div className="d-flex justify-content-center my-3">
                    <Pagination>
                      {this.props.simulasiTarif.hasPrev && (
                        <PaginationItem>
                          <PaginationLink
                            first
                            onClick={() =>
                              this.setState({ ...this.state, curPage: 1 })
                            }
                          />
                        </PaginationItem>
                      )}

                      {this.props.simulasiTarif.hasPrev && (
                        <PaginationItem>
                          <PaginationLink
                            previous
                            onClick={() =>
                              this.setState({
                                ...this.state,
                                curPage: prevPage,
                              })
                            }
                          />
                        </PaginationItem>
                      )}

                      {pages.map((item, index) => {
                        let actived = false;
                        if (curPage === undefined) {
                          curPage = 1;
                        }
                        if (item == curPage) {
                          actived = true;
                        }

                        if (item >= minPage && item <= maxPage) {
                          return (
                            <PaginationItem
                              active={actived}
                              key={`pagination-${index}`}
                            >
                              <PaginationLink
                                onClick={() =>
                                  this.setState({
                                    ...this.state,
                                    curPage: item,
                                  })
                                }
                                style={{
                                  backgroundColor: actived && "#224B98",
                                }}
                              >
                                {item}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        }
                      })}

                      {this.props.simulasiTarif.hasNext && (
                        <PaginationItem>
                          <PaginationLink
                            next
                            onClick={() =>
                              this.setState({
                                ...this.state,
                                curPage: nextPage,
                              })
                            }
                          />
                        </PaginationItem>
                      )}

                      {this.props.simulasiTarif.hasNext && (
                        <PaginationItem>
                          <PaginationLink
                            last
                            onClick={() =>
                              this.setState({
                                ...this.state,
                                curPage: totalPages,
                              })
                            }
                          />
                        </PaginationItem>
                      )}
                    </Pagination>
                  </div> */}
                </>
              )}

            {this.props.simulasiTarif.length < 1 &&
              !this.props.searchSimulasiTarifLoading && (
                <>
                  <Table borderless responsive style={{ color: "#224B98" }}>
                    <thead>
                      <tr>
                        <th>Kode Trayek</th>
                        {/* <th>Origin</th> */}
                        {/* <th>Destination</th> */}
                        <th>Total Tarif Kontainer</th>
                        <th>Tarif Pelabuhan</th>
                        <th>Tarif Depo</th>
                        <th>Tarif Shipper</th>
                        {/* <th>Shipper</th> */}
                        <th>Total Tarif</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                          colSpan="8"
                        >
                          Cari Data
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </>
              )}
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ports: state.ports.ports,
  portGetSuccess: state.ports.portGetSuccess,
  portGetLoading: state.ports.portGetLoading,
  portGetError: state.ports.portGetError,

  searchSimulasiTarifLoading: state.simulasiTarif.searchSimulasiTarifLoading,
  searchSimulasiTarifSuccess: state.simulasiTarif.searchSimulasiTarifSuccess,
  searchSimulasiTarifError: state.simulasiTarif.searchSimulasiTarifError,
  simulasiTarif: state.simulasiTarif.simulasiTarif,

  listShipperGetLoading: state.simulasiTarif.listShipperGetLoading,
  listShipperGetError: state.simulasiTarif.listShipperGetError,
  listShipperGetSuccess: state.simulasiTarif.listShipperGetSuccess,
  listShipper: state.simulasiTarif.listShipper,

  typeContainerGetLoading: state.simulasiTarif.typecontainerGetLoading,
  typeContainerGetError: state.simulasiTarif.typecontainerGetError,
  typeContainerGetSuccess: state.simulasiTarif.typecontainerGetSuccess,
  typeContainers: state.simulasiTarif.typecontainers,
});

const mapDispatchToProps = (dispatch) => {
  return {
    portFetchAll: () => dispatch(portFetchAll()),
    searchSimulasiTarif: (data) => dispatch(searchSimulasiTarifNew(data)),
    listShipperFetchSub: (idOrigin, idDestination) =>
      dispatch(listShipperFetchSub(idOrigin, idDestination)),
    typeContainerPortal: (data) => dispatch(typeContainerPortal(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimulasiTarif);
